/* eslint react/prefer-stateless-function: 0 */

import React from 'react';
import ReactRouterPropTypes from 'react-router-prop-types';
import {
  Text,
  View,
} from 'react-native';
import Autolink from 'react-native-autolink';

import Header from '../../components/misc/Header';
import styles from '../../styles';
import { translate } from '../../locales/i18n';
import ScrollFading from '../../components/effects/ScrollFading';

class About extends React.Component {
  constructor(props, context) {
    super(props, context);

    // eslint-disable-next-line react/no-unused-class-component-methods
    this.displayName = 'About';
  }

  render() {
    const { history } = this.props;

    const t = translate('company_about');
    const paragraphs = t.split('\n\n');

    return (
      <View
        style={styles.view.headed}
      >
        <Header
          name={translate('menu_project_info')}
          hasCancel
          history={history}
        />

        <ScrollFading>
          {paragraphs.map((paragraph, idx) => (
            <Text key={`paragraph${idx}`} style={styles.common.paragraph}>
              <Autolink url text={paragraph} />
            </Text>
          ))}
        </ScrollFading>
      </View>
    );
  }
}

About.propTypes = {
  history: ReactRouterPropTypes.history.isRequired,
};

export default About;
